export class BaseQuickJob {
    id = '';
    companyId = '';
    dispatchOfficeLocationId = '';
    dispatchPortId = '';
    contractId = '';

    jobLocation = {};
    meetingLocation = {};
    projectId = '';
    isIntercompanyCustomer = false;
    projectName = '';
    projectManagerId = '';
    inspectorName = '';
}